'use client';
import {Context, createContext, ReactNode} from "react";
import {TrmzFile} from "@web-libs/features/files/trmz-file/domain/trmz-file.types";

export const LogoContext:Context<TrmzFile|null> = createContext<TrmzFile|null>(null)

export const LogoProvider = ({children, file}: { children: ReactNode, file?: TrmzFile }) => {
    return (
        <LogoContext.Provider value={file ?? null}>
            {children}
        </LogoContext.Provider>
    )
}
